export const getImageUrlWithAuth = (url: string | undefined, idToken: string) =>
  url ? `${url}?token=${idToken}` : '';
